function ratio(cur, max) {
    return { value: Math.min(1, cur / max), label: `${Math.min(cur, max)} / ${max}` };
}
function flag(done) {
    return { value: done ? 1 : 0, label: done ? 'получено' : 'ещё нет' };
}
/**
 * Реестр ачивок. Проверяется на сервере после каждой сессии —
 * клиенту доверять нельзя, иначе всё открывается через консоль браузера.
 */
export const ACHIEVEMENTS = [
    {
        code: 'first_steps',
        title: 'Первые шаги',
        emoji: '🐣',
        description: 'Пройти первую тренировку',
        progress: (c) => ratio(c.totalSessions, 1),
    },
    {
        code: 'flawless',
        title: 'Без промаха',
        emoji: '🎯',
        description: 'Пройти тренировку из 10+ примеров без единой ошибки',
        progress: (c) => flag(c.hadFlawlessRun),
    },
    {
        code: 'lightning',
        title: 'Молния',
        emoji: '⚡',
        description: 'Ответить верно быстрее чем за 1,5 секунды',
        progress: (c) => flag(c.fastestCorrectMs > 0 && c.fastestCorrectMs < 1500),
    },
    {
        code: 'combo_20',
        title: 'На волне',
        emoji: '🌊',
        description: '20 верных ответов подряд',
        progress: (c) => ratio(c.bestCombo, 20),
    },
    {
        code: 'sprinter',
        title: 'Скорострел',
        emoji: '🏃',
        description: 'Набрать 300 очков за один спринт',
        progress: (c) => ratio(c.bestSprintScore, 300),
    },
    {
        code: 'century',
        title: 'Сотня',
        emoji: '💯',
        description: 'Решить 100 примеров',
        progress: (c) => ratio(c.totalCorrect, 100),
    },
    {
        code: 'thousand',
        title: 'Тысяча',
        emoji: '🏆',
        description: 'Решить 1000 примеров',
        progress: (c) => ratio(c.totalCorrect, 1000),
    },
    {
        code: 'streak_3',
        title: 'Разогрев',
        emoji: '🔥',
        description: '3 дня подряд с выполненным заданием',
        progress: (c) => ratio(c.bestStreakDays, 3),
    },
    {
        code: 'streak_7',
        title: 'Неделя огня',
        emoji: '🔥',
        description: '7 дней подряд с выполненным заданием',
        progress: (c) => ratio(c.bestStreakDays, 7),
    },
    {
        code: 'streak_30',
        title: 'Железная воля',
        emoji: '💪',
        description: '30 дней подряд с выполненным заданием',
        progress: (c) => ratio(c.bestStreakDays, 30),
    },
    {
        code: 'perfect_week',
        title: 'Идеальная неделя',
        emoji: '📅',
        description: 'Выполнить задание дня 7 раз за 7 дней',
        progress: (c) => flag(c.perfectWeek),
    },
    {
        code: 'duelist',
        title: 'Дуэлянт',
        emoji: '⚔️',
        description: 'Сыграть первую дуэль с другом',
        progress: (c) => ratio(c.duelsPlayed, 1),
    },
    {
        code: 'champion',
        title: 'Чемпион',
        emoji: '👑',
        description: 'Выиграть 5 дуэлей',
        progress: (c) => ratio(c.duelsWon, 5),
    },
    {
        code: 'division_master',
        title: 'Мастер деления',
        emoji: '➗',
        description: 'Решить 200 примеров на деление',
        progress: (c) => ratio(c.divisionCorrect, 200),
    },
    {
        code: 'night_owl',
        title: 'Ночной математик',
        emoji: '🦉',
        description: 'Позаниматься после 22:00',
        progress: (c) => flag(c.lastActivityHour >= 22),
        secret: true,
    },
    {
        code: 'early_bird',
        title: 'Ранняя пташка',
        emoji: '🌅',
        description: 'Позаниматься до 7:00',
        progress: (c) => flag(c.lastActivityHour < 7),
        secret: true,
    },
    {
        code: 'table_master',
        title: 'Знаток таблицы',
        emoji: '🎓',
        description: 'Полностью освоить любые 3 таблицы',
        progress: (c) => ratio(c.masteredTables.length, 3),
    },
    {
        code: 'full_table',
        title: 'Вся таблица',
        emoji: '🌟',
        description: 'Освоить всю таблицу умножения целиком',
        progress: (c) => ({
            value: c.masteredRatio,
            label: `${Math.round(c.masteredRatio * 100)}%`,
        }),
    },
];
const BY_CODE = new Map(ACHIEVEMENTS.map((a) => [a.code, a]));
export function getAchievement(code) {
    return BY_CODE.get(code);
}
/**
 * Полное состояние всех ачивок.
 * @param unlocked уже разблокированные ранее: код -> момент разблокировки
 */
export function evaluateAchievements(ctx, unlocked) {
    return ACHIEVEMENTS.map((rule) => {
        const p = rule.progress(ctx);
        const already = unlocked.get(rule.code) ?? null;
        return {
            code: rule.code,
            unlockedAt: already,
            progress: p.value,
            progressLabel: p.label,
        };
    });
}
/** Какие ачивки открылись прямо сейчас (были заперты, а условие уже выполнено). */
export function newlyUnlocked(ctx, unlocked) {
    const out = [];
    for (const rule of ACHIEVEMENTS) {
        if (unlocked.has(rule.code))
            continue;
        if (rule.progress(ctx).value >= 1)
            out.push(rule.code);
    }
    return out;
}
//# sourceMappingURL=achievements.js.map